/**
 * A function that always returns the value of `null`
 */
function alwaysNull() {
  return null;
}

export default alwaysNull;
